import {
    GET_MENU_APP
  } from 'shared/constants/ActionTypes';
  
  const INIT_STATE = {
   list: []
  };
  
  const menuReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
      case GET_MENU_APP: {
        return {
          ...state,
          list: action.payload
        }
      }
      default:
        return state;
    }
  };
  export default menuReducer;
  